module.exports = __webpack_public_path__ + "static/media/salesforce.f9def25b.png";